import React from 'react';
import styled from 'styled-components';
import { Rating } from 'semantic-ui-react';

const RatingContainer = styled.div`
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    max-width: 300px;
    margin-bottom: 6px;
`;

const StarScale = ({ input }) => (
    <RatingContainer>
        <Rating
            style={{ width: '100%' }}
            onRate={(event, { rating }) => input.onChange(rating)}
            rating={input.value}
            size={'massive'}
            maxRating={5}
            icon={'star'}
        />
    </RatingContainer>
);

export default StarScale;



// WEBPACK FOOTER //
// ./src/components/molecules/StarScale.js